import { useEffect, useRef } from "react";

export const useReveal = (options = {}) => {
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        el.classList.add("is-visible");
                        obs.unobserve(el);
                    }
                });
            },
            { threshold: 0.15, rootMargin: "0px 0px -80px 0px", ...options }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, []);

    return ref;
};

export const Reveal = ({ children, className = "", delay = 0, as: As = "div", ...rest }) => {
    const ref = useReveal();
    return (
        <As
            ref={ref}
            className={`reveal ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
            {...rest}
        >
            {children}
        </As>
    );
};
